var map = {
  "./admin/CW-Logo-light.svg": "16974",
  "./admin/feather-sprite.svg": "83164",
  "./admin/icons/activity.svg": "93051",
  "./admin/icons/airplay.svg": "29382",
  "./admin/icons/alert-circle.svg": "45363",
  "./admin/icons/alert-octagon.svg": "8360",
  "./admin/icons/alert-triangle.svg": "68207",
  "./admin/icons/align-center.svg": "96735",
  "./admin/icons/align-justify.svg": "8324",
  "./admin/icons/align-left.svg": "42615",
  "./admin/icons/align-right.svg": "3314",
  "./admin/icons/anchor.svg": "35239",
  "./admin/icons/aperture.svg": "28540",
  "./admin/icons/archive.svg": "30622",
  "./admin/icons/arrow-down-circle.svg": "49718",
  "./admin/icons/arrow-down-left.svg": "54102",
  "./admin/icons/arrow-down-right.svg": "11413",
  "./admin/icons/arrow-down.svg": "91964",
  "./admin/icons/arrow-left-circle.svg": "69768",
  "./admin/icons/arrow-left.svg": "14411",
  "./admin/icons/arrow-right-circle.svg": "1003",
  "./admin/icons/arrow-right.svg": "37486",
  "./admin/icons/arrow-up-circle.svg": "49332",
  "./admin/icons/arrow-up-left.svg": "85899",
  "./admin/icons/arrow-up-right.svg": "32686",
  "./admin/icons/arrow-up.svg": "17815",
  "./admin/icons/at-sign.svg": "40263",
  "./admin/icons/award.svg": "62911",
  "./admin/icons/bar-chart-2.svg": "64137",
  "./admin/icons/bar-chart.svg": "8500",
  "./admin/icons/battery-charging.svg": "57521",
  "./admin/icons/battery.svg": "48531",
  "./admin/icons/bell-off.svg": "71135",
  "./admin/icons/bell.svg": "27655",
  "./admin/icons/bluetooth.svg": "11706",
  "./admin/icons/bold.svg": "37941",
  "./admin/icons/book-open.svg": "80980",
  "./admin/icons/book.svg": "30379",
  "./admin/icons/bookmark.svg": "87108",
  "./admin/icons/box.svg": "66863",
  "./admin/icons/briefcase.svg": "19632",
  "./admin/icons/calendar.svg": "14862",
  "./admin/icons/camera-off.svg": "349",
  "./admin/icons/camera.svg": "95561",
  "./admin/icons/cast.svg": "76625",
  "./admin/icons/check-circle.svg": "49665",
  "./admin/icons/check-square.svg": "13188",
  "./admin/icons/check.svg": "34836",
  "./admin/icons/chevron-down.svg": "64098",
  "./admin/icons/chevron-left.svg": "86921",
  "./admin/icons/chevron-right.svg": "76788",
  "./admin/icons/chevron-up.svg": "3665",
  "./admin/icons/chevrons-down.svg": "99245",
  "./admin/icons/chevrons-left.svg": "44182",
  "./admin/icons/chevrons-right.svg": "79989",
  "./admin/icons/chevrons-up.svg": "3346",
  "./admin/icons/chrome.svg": "35274",
  "./admin/icons/circle.svg": "7696",
  "./admin/icons/clipboard.svg": "82774",
  "./admin/icons/clock.svg": "96214",
  "./admin/icons/cloud-drizzle.svg": "56034",
  "./admin/icons/cloud-lightning.svg": "99350",
  "./admin/icons/cloud-off.svg": "65031",
  "./admin/icons/cloud-rain.svg": "40306",
  "./admin/icons/cloud-snow.svg": "52049",
  "./admin/icons/cloud.svg": "82159",
  "./admin/icons/code.svg": "92115",
  "./admin/icons/codepen.svg": "82572",
  "./admin/icons/coffee.svg": "60208",
  "./admin/icons/command.svg": "56207",
  "./admin/icons/compass.svg": "60452",
  "./admin/icons/copy.svg": "84795",
  "./admin/icons/corner-down-left.svg": "80554",
  "./admin/icons/corner-down-right.svg": "23361",
  "./admin/icons/corner-left-down.svg": "8964",
  "./admin/icons/corner-left-up.svg": "85151",
  "./admin/icons/corner-right-down.svg": "15827",
  "./admin/icons/corner-right-up.svg": "73804",
  "./admin/icons/corner-up-left.svg": "23671",
  "./admin/icons/corner-up-right.svg": "88370",
  "./admin/icons/cpu.svg": "7186",
  "./admin/icons/credit-card.svg": "798",
  "./admin/icons/crop.svg": "66334",
  "./admin/icons/crosshair.svg": "91200",
  "./admin/icons/database.svg": "63851",
  "./admin/icons/delete.svg": "3909",
  "./admin/icons/disc.svg": "84627",
  "./admin/icons/dollar-sign.svg": "60404",
  "./admin/icons/download-cloud.svg": "83408",
  "./admin/icons/download.svg": "34980",
  "./admin/icons/droplet.svg": "14426",
  "./admin/icons/edit-2.svg": "20805",
  "./admin/icons/edit-3.svg": "42788",
  "./admin/icons/edit.svg": "40008",
  "./admin/icons/external-link.svg": "48486",
  "./admin/icons/eye-off.svg": "62267",
  "./admin/icons/eye.svg": "55795",
  "./admin/icons/facebook.svg": "73136",
  "./admin/icons/fast-forward.svg": "50150",
  "./admin/icons/feather.svg": "70393",
  "./admin/icons/file-minus.svg": "86685",
  "./admin/icons/file-plus.svg": "39247",
  "./admin/icons/file-text.svg": "38426",
  "./admin/icons/file.svg": "97670",
  "./admin/icons/film.svg": "13998",
  "./admin/icons/filter.svg": "62362",
  "./admin/icons/flag.svg": "4546",
  "./admin/icons/folder-minus.svg": "88719",
  "./admin/icons/folder-plus.svg": "66945",
  "./admin/icons/folder.svg": "51592",
  "./admin/icons/frown.svg": "20484",
  "./admin/icons/gift.svg": "79750",
  "./admin/icons/git-branch.svg": "21441",
  "./admin/icons/git-commit.svg": "86142",
  "./admin/icons/git-merge.svg": "81459",
  "./admin/icons/git-pull-request.svg": "10372",
  "./admin/icons/github.svg": "23281",
  "./admin/icons/gitlab.svg": "91641",
  "./admin/icons/globe.svg": "667",
  "./admin/icons/grid.svg": "49516",
  "./admin/icons/hard-drive.svg": "50684",
  "./admin/icons/hash.svg": "83132",
  "./admin/icons/headphones.svg": "26197",
  "./admin/icons/heart.svg": "15712",
  "./admin/icons/help-circle.svg": "65498",
  "./admin/icons/home.svg": "32585",
  "./admin/icons/image.svg": "19123",
  "./admin/icons/inbox.svg": "24404",
  "./admin/icons/info.svg": "83456",
  "./admin/icons/instagram.svg": "200",
  "./admin/icons/italic.svg": "96508",
  "./admin/icons/layers.svg": "63290",
  "./admin/icons/layout.svg": "70190",
  "./admin/icons/life-buoy.svg": "66536",
  "./admin/icons/link-2.svg": "58577",
  "./admin/icons/link.svg": "82764",
  "./admin/icons/linkedin.svg": "42130",
  "./admin/icons/list.svg": "55524",
  "./admin/icons/loader.svg": "93061",
  "./admin/icons/lock.svg": "13969",
  "./admin/icons/log-in.svg": "29254",
  "./admin/icons/log-out.svg": "98081",
  "./admin/icons/mail.svg": "33121",
  "./admin/icons/map-pin.svg": "14012",
  "./admin/icons/map.svg": "88510",
  "./admin/icons/maximize-2.svg": "46379",
  "./admin/icons/maximize.svg": "23530",
  "./admin/icons/meh.svg": "57290",
  "./admin/icons/menu.svg": "36350",
  "./admin/icons/message-circle.svg": "20790",
  "./admin/icons/message-square.svg": "80331",
  "./admin/icons/mic-off.svg": "25305",
  "./admin/icons/mic.svg": "6677",
  "./admin/icons/minimize-2.svg": "71905",
  "./admin/icons/minimize.svg": "50524",
  "./admin/icons/minus-circle.svg": "93041",
  "./admin/icons/minus-square.svg": "55956",
  "./admin/icons/minus.svg": "72004",
  "./admin/icons/monitor.svg": "65966",
  "./admin/icons/moon.svg": "69895",
  "./admin/icons/more-horizontal.svg": "59240",
  "./admin/icons/more-vertical.svg": "81112",
  "./admin/icons/move.svg": "28803",
  "./admin/icons/music.svg": "3701",
  "./admin/icons/navigation-2.svg": "22235",
  "./admin/icons/navigation.svg": "12794",
  "./admin/icons/octagon.svg": "70661",
  "./admin/icons/package.svg": "70964",
  "./admin/icons/paperclip.svg": "65464",
  "./admin/icons/pause-circle.svg": "1023",
  "./admin/icons/pause.svg": "46098",
  "./admin/icons/percent.svg": "47871",
  "./admin/icons/phone-call.svg": "35949",
  "./admin/icons/phone-forwarded.svg": "75431",
  "./admin/icons/phone-incoming.svg": "15125",
  "./admin/icons/phone-missed.svg": "12182",
  "./admin/icons/phone-off.svg": "73372",
  "./admin/icons/phone-outgoing.svg": "13483",
  "./admin/icons/phone.svg": "5144",
  "./admin/icons/pie-chart.svg": "58757",
  "./admin/icons/play-circle.svg": "12079",
  "./admin/icons/play.svg": "54210",
  "./admin/icons/plus-circle.svg": "48729",
  "./admin/icons/plus-square.svg": "22972",
  "./admin/icons/plus.svg": "96812",
  "./admin/icons/pocket.svg": "15474",
  "./admin/icons/power.svg": "8991",
  "./admin/icons/printer.svg": "41080",
  "./admin/icons/radio.svg": "62261",
  "./admin/icons/refresh-ccw.svg": "35323",
  "./admin/icons/refresh-cw.svg": "84688",
  "./admin/icons/repeat.svg": "60721",
  "./admin/icons/rewind.svg": "40845",
  "./admin/icons/rotate-ccw.svg": "59663",
  "./admin/icons/rotate-cw.svg": "86812",
  "./admin/icons/rss.svg": "78872",
  "./admin/icons/save.svg": "32435",
  "./admin/icons/scissors.svg": "67685",
  "./admin/icons/search.svg": "24352",
  "./admin/icons/send.svg": "45086",
  "./admin/icons/server.svg": "93773",
  "./admin/icons/settings.svg": "91195",
  "./admin/icons/share-2.svg": "49012",
  "./admin/icons/share.svg": "92069",
  "./admin/icons/shield-off.svg": "13759",
  "./admin/icons/shield.svg": "10535",
  "./admin/icons/shopping-bag.svg": "97341",
  "./admin/icons/shopping-cart.svg": "89475",
  "./admin/icons/shuffle.svg": "4767",
  "./admin/icons/sidebar.svg": "56072",
  "./admin/icons/skip-back.svg": "97507",
  "./admin/icons/skip-forward.svg": "14021",
  "./admin/icons/slack.svg": "46748",
  "./admin/icons/slash.svg": "61951",
  "./admin/icons/sliders.svg": "77434",
  "./admin/icons/smartphone.svg": "38445",
  "./admin/icons/smile.svg": "51184",
  "./admin/icons/speaker.svg": "52039",
  "./admin/icons/square.svg": "20729",
  "./admin/icons/star.svg": "43748",
  "./admin/icons/stop-circle.svg": "22785",
  "./admin/icons/sun.svg": "85182",
  "./admin/icons/sunrise.svg": "12341",
  "./admin/icons/sunset.svg": "6382",
  "./admin/icons/tablet.svg": "9516",
  "./admin/icons/tag.svg": "6868",
  "./admin/icons/target.svg": "70879",
  "./admin/icons/terminal.svg": "94012",
  "./admin/icons/thermometer.svg": "2376",
  "./admin/icons/thumbs-down.svg": "45596",
  "./admin/icons/thumbs-up.svg": "49815",
  "./admin/icons/toggle-left.svg": "6194",
  "./admin/icons/toggle-right.svg": "42665",
  "./admin/icons/trash-2.svg": "83843",
  "./admin/icons/trash.svg": "47698",
  "./admin/icons/trello.svg": "72454",
  "./admin/icons/trending-down.svg": "83196",
  "./admin/icons/trending-up.svg": "41559",
  "./admin/icons/triangle.svg": "18792",
  "./admin/icons/truck.svg": "14581",
  "./admin/icons/tv.svg": "58790",
  "./admin/icons/twitter.svg": "37361",
  "./admin/icons/type.svg": "94164",
  "./admin/icons/umbrella.svg": "75784",
  "./admin/icons/underline.svg": "11992",
  "./admin/icons/unlock.svg": "88440",
  "./admin/icons/upload-cloud.svg": "88507",
  "./admin/icons/upload.svg": "68119",
  "./admin/icons/user-check.svg": "50226",
  "./admin/icons/user-minus.svg": "82670",
  "./admin/icons/user-plus.svg": "21510",
  "./admin/icons/user-x.svg": "96646",
  "./admin/icons/user.svg": "95309",
  "./admin/icons/users.svg": "88388",
  "./admin/icons/video-off.svg": "43033",
  "./admin/icons/video.svg": "46645",
  "./admin/icons/voicemail.svg": "63823",
  "./admin/icons/volume-1.svg": "78792",
  "./admin/icons/volume-2.svg": "13179",
  "./admin/icons/volume-x.svg": "87969",
  "./admin/icons/volume.svg": "34778",
  "./admin/icons/watch.svg": "8381",
  "./admin/icons/wifi-off.svg": "76763",
  "./admin/icons/wifi.svg": "45843",
  "./admin/icons/wind.svg": "38334",
  "./admin/icons/x-circle.svg": "377",
  "./admin/icons/x-square.svg": "5404",
  "./admin/icons/x.svg": "77068",
  "./admin/icons/youtube.svg": "62967",
  "./admin/icons/zap-off.svg": "89869",
  "./admin/icons/zap.svg": "17689",
  "./admin/icons/zoom-in.svg": "9827",
  "./admin/icons/zoom-out.svg": "67142",
  "./admin/node_builder_img/brands_logo/aws.svg": "49342",
  "./admin/node_builder_img/brands_logo/azure.svg": "69172",
  "./admin/node_builder_img/brands_logo/gemini.svg": "63606",
  "./admin/node_builder_img/brands_logo/google.svg": "48430",
  "./admin/node_builder_img/brands_logo/lxt.svg": "78105",
  "./admin/node_builder_img/brands_logo/microsoft.svg": "56641",
  "./admin/node_builder_img/brands_logo/openai.svg": "71125",
  "./admin/node_builder_img/icons/buyoff.svg": "17798",
  "./admin/node_builder_img/icons/createnode.svg": "54621",
  "./admin/node_builder_img/icons/data_annotation.svg": "56287",
  "./admin/node_builder_img/icons/data_annotation_validation.svg": "86855",
  "./admin/node_builder_img/icons/editnode.svg": "42745",
  "./admin/node_builder_img/icons/genai.svg": "81527",
  "./admin/node_builder_img/icons/ldp.svg": "73607",
  "./admin/node_builder_img/icons/llm.svg": "84122",
  "./admin/node_builder_img/icons/pre_annotation_llm.svg": "40560",
  "./admin/node_builder_img/icons/robotnode.svg": "3215",
  "./admin/node_builder_img/icons/startnode.svg": "60559",
  "./admin/node_builder_img/icons/stopnode.svg": "6925",
  "./admin/node_builder_img/icons/validationnode.svg": "94916",
  "./clickworker_com/2fa_step_1.png": "77443",
  "./clickworker_com/2fa_step_2.png": "99112",
  "./clickworker_com/2fa_step_3.png": "47505",
  "./clickworker_com/2fa_step_4.png": "2942",
  "./clickworker_com/app_download_qr_code.png": "31187",
  "./clickworker_com/clickworker_werben.png": "43929",
  "./clickworker_com/f2a_step_1_de.png": "94413",
  "./clickworker_com/f2a_step_2_de.png": "89164",
  "./clickworker_com/f2a_step_3_de.png": "75219",
  "./clickworker_logo_neu.png": "41523",
  "./crunchBase.png": "22498",
  "./facebook.png": "45158",
  "./favicon.ico": "66498",
  "./flags/3a.svg": "43617",
  "./flags/ad.svg": "62402",
  "./flags/ae.svg": "66131",
  "./flags/af.svg": "5120",
  "./flags/ag.svg": "19505",
  "./flags/ai.svg": "57303",
  "./flags/al.svg": "76570",
  "./flags/am.svg": "70443",
  "./flags/an.svg": "12376",
  "./flags/ao.svg": "37737",
  "./flags/aq.svg": "22671",
  "./flags/ar.svg": "20348",
  "./flags/as.svg": "48893",
  "./flags/at.svg": "14962",
  "./flags/au.svg": "18275",
  "./flags/aw.svg": "20001",
  "./flags/ax.svg": "62582",
  "./flags/az.svg": "61236",
  "./flags/ba.svg": "11845",
  "./flags/bb.svg": "22913",
  "./flags/bd.svg": "76559",
  "./flags/be.svg": "13982",
  "./flags/bf.svg": "68157",
  "./flags/bg.svg": "97532",
  "./flags/bh.svg": "48795",
  "./flags/bi.svg": "30954",
  "./flags/bj.svg": "91705",
  "./flags/bl.svg": "87239",
  "./flags/bm.svg": "118",
  "./flags/bn.svg": "41365",
  "./flags/bo.svg": "15732",
  "./flags/bq.svg": "67874",
  "./flags/br.svg": "22417",
  "./flags/bs.svg": "75968",
  "./flags/bt.svg": "18175",
  "./flags/bv.svg": "42541",
  "./flags/bw.svg": "62828",
  "./flags/by.svg": "51418",
  "./flags/bz.svg": "50153",
  "./flags/ca.svg": "74833",
  "./flags/cat.svg": "88159",
  "./flags/cc.svg": "82931",
  "./flags/cd.svg": "15244",
  "./flags/cf.svg": "65838",
  "./flags/cg.svg": "70591",
  "./flags/ch.svg": "67704",
  "./flags/ci.svg": "2569",
  "./flags/ck.svg": "22891",
  "./flags/cl.svg": "60740",
  "./flags/cm.svg": "15461",
  "./flags/cn.svg": "16326",
  "./flags/co.svg": "87511",
  "./flags/cr.svg": "86642",
  "./flags/cu.svg": "20573",
  "./flags/cv.svg": "66398",
  "./flags/cw.svg": "28975",
  "./flags/cx.svg": "19848",
  "./flags/cy.svg": "44121",
  "./flags/cz.svg": "83370",
  "./flags/de.svg": "18720",
  "./flags/dj.svg": "77847",
  "./flags/dk.svg": "6662",
  "./flags/dm.svg": "58040",
  "./flags/do.svg": "71789",
  "./flags/dz.svg": "29991",
  "./flags/ec.svg": "15899",
  "./flags/ee.svg": "90159",
  "./flags/eg.svg": "23325",
  "./flags/eh.svg": "71402",
  "./flags/er.svg": "53376",
  "./flags/es.svg": "93937",
  "./flags/et.svg": "28462",
  "./flags/eu.svg": "66399",
  "./flags/fi.svg": "26942",
  "./flags/fj.svg": "81117",
  "./flags/fk.svg": "91644",
  "./flags/fm.svg": "47186",
  "./flags/fo.svg": "4784",
  "./flags/fr.svg": "6629",
  "./flags/ga.svg": "59045",
  "./flags/gb-eng.svg": "13477",
  "./flags/gb-nir.svg": "70986",
  "./flags/gb-sct.svg": "79775",
  "./flags/gb-wls.svg": "8597",
  "./flags/gb.svg": "36614",
  "./flags/gd.svg": "61816",
  "./flags/ge.svg": "66057",
  "./flags/gf.svg": "97946",
  "./flags/gg.svg": "12555",
  "./flags/gh.svg": "85676",
  "./flags/gi.svg": "84621",
  "./flags/gl.svg": "98816",
  "./flags/gm.svg": "34769",
  "./flags/gn.svg": "14402",
  "./flags/gp.svg": "81108",
  "./flags/gq.svg": "53717",
  "./flags/gr.svg": "81846",
  "./flags/gs.svg": "45671",
  "./flags/gt.svg": "56488",
  "./flags/gu.svg": "38233",
  "./flags/gw.svg": "7227",
  "./flags/gy.svg": "33533",
  "./flags/hk.svg": "37194",
  "./flags/hm.svg": "71444",
  "./flags/hn.svg": "36007",
  "./flags/hr.svg": "9907",
  "./flags/ht.svg": "74957",
  "./flags/hu.svg": "76012",
  "./flags/ic.svg": "20789",
  "./flags/id.svg": "91690",
  "./flags/ie.svg": "60507",
  "./flags/il.svg": "52882",
  "./flags/im.svg": "78576",
  "./flags/in.svg": "66800",
  "./flags/io.svg": "57921",
  "./flags/iq.svg": "95223",
  "./flags/ir.svg": "40772",
  "./flags/is.svg": "21669",
  "./flags/it.svg": "14490",
  "./flags/je.svg": "42310",
  "./flags/jm.svg": "98286",
  "./flags/jo.svg": "33900",
  "./flags/jp.svg": "12923",
  "./flags/ke.svg": "31701",
  "./flags/kg.svg": "77575",
  "./flags/kh.svg": "1008",
  "./flags/ki.svg": "13249",
  "./flags/km.svg": "58493",
  "./flags/kn.svg": "4318",
  "./flags/kp.svg": "5624",
  "./flags/kr.svg": "41754",
  "./flags/ku.svg": "53381",
  "./flags/kw.svg": "25431",
  "./flags/ky.svg": "12753",
  "./flags/kz.svg": "58210",
  "./flags/la.svg": "96404",
  "./flags/lang.svg": "55305",
  "./flags/lb.svg": "67911",
  "./flags/lc.svg": "80790",
  "./flags/li.svg": "78204",
  "./flags/lk.svg": "94654",
  "./flags/lr.svg": "15767",
  "./flags/ls.svg": "28230",
  "./flags/lt.svg": "30825",
  "./flags/lu.svg": "95960",
  "./flags/lv.svg": "51147",
  "./flags/ly.svg": "43500",
  "./flags/ma.svg": "3563",
  "./flags/mc.svg": "99593",
  "./flags/md.svg": "96998",
  "./flags/me.svg": "90564",
  "./flags/mf.svg": "41412",
  "./flags/mg.svg": "96133",
  "./flags/mh.svg": "962",
  "./flags/mk.svg": "55505",
  "./flags/ml.svg": "46510",
  "./flags/mm.svg": "51263",
  "./flags/mn.svg": "95916",
  "./flags/mo.svg": "75629",
  "./flags/mp.svg": "64042",
  "./flags/mq.svg": "98235",
  "./flags/mr.svg": "520",
  "./flags/ms.svg": "47174",
  "./flags/mt.svg": "10825",
  "./flags/mu.svg": "20327",
  "./flags/mv.svg": "48820",
  "./flags/mw.svg": "90805",
  "./flags/mx.svg": "67314",
  "./flags/my.svg": "5251",
  "./flags/mz.svg": "43760",
  "./flags/na.svg": "1566",
  "./flags/nc.svg": "1468",
  "./flags/ne.svg": "79730",
  "./flags/nf.svg": "61473",
  "./flags/ng.svg": "63024",
  "./flags/ni.svg": "4054",
  "./flags/nl.svg": "87355",
  "./flags/no.svg": "5992",
  "./flags/np.svg": "56735",
  "./flags/nr.svg": "29517",
  "./flags/nu.svg": "20226",
  "./flags/nz.svg": "22341",
  "./flags/om.svg": "81769",
  "./flags/pa.svg": "96600",
  "./flags/pe.svg": "87076",
  "./flags/pf.svg": "91671",
  "./flags/pg.svg": "28870",
  "./flags/ph.svg": "27025",
  "./flags/pk.svg": "62978",
  "./flags/pl.svg": "72269",
  "./flags/pm.svg": "20460",
  "./flags/pn.svg": "99487",
  "./flags/pr.svg": "30107",
  "./flags/ps.svg": "4490",
  "./flags/pt.svg": "59765",
  "./flags/pw.svg": "46806",
  "./flags/py.svg": "5776",
  "./flags/qa.svg": "3759",
  "./flags/re.svg": "69358",
  "./flags/ro.svg": "40964",
  "./flags/rs.svg": "90288",
  "./flags/ru.svg": "12446",
  "./flags/rw.svg": "77148",
  "./flags/sa.svg": "673",
  "./flags/sb.svg": "95634",
  "./flags/sc.svg": "98947",
  "./flags/sd.svg": "1020",
  "./flags/se.svg": "29565",
  "./flags/sg.svg": "3343",
  "./flags/sh.svg": "87720",
  "./flags/si.svg": "83737",
  "./flags/sj.svg": "34442",
  "./flags/sk.svg": "3259",
  "./flags/sl.svg": "41908",
  "./flags/sm.svg": "63541",
  "./flags/sn.svg": "43254",
  "./flags/so.svg": "90119",
  "./flags/sr.svg": "43074",
  "./flags/ss.svg": "46803",
  "./flags/st.svg": "24236",
  "./flags/sv.svg": "88622",
  "./flags/sx.svg": "93048",
  "./flags/sy.svg": "18409",
  "./flags/sz.svg": "57242",
  "./flags/tc.svg": "73630",
  "./flags/td.svg": "91009",
  "./flags/tf.svg": "89283",
  "./flags/tg.svg": "85970",
  "./flags/th.svg": "53877",
  "./flags/tj.svg": "80455",
  "./flags/tk.svg": "33590",
  "./flags/tl.svg": "74073",
  "./flags/tm.svg": "78056",
  "./flags/tn.svg": "93595",
  "./flags/to.svg": "24778",
  "./flags/tr.svg": "93599",
  "./flags/tt.svg": "90513",
  "./flags/tv.svg": "37139",
  "./flags/tw.svg": "33410",
  "./flags/tz.svg": "28311",
  "./flags/ua.svg": "89555",
  "./flags/ug.svg": "14349",
  "./flags/um.svg": "80727",
  "./flags/us.svg": "43425",
  "./flags/uy.svg": "46011",
  "./flags/uz.svg": "30472",
  "./flags/va.svg": "87334",
  "./flags/vc.svg": "31748",
  "./flags/ve.svg": "74842",
  "./flags/vg.svg": "38712",
  "./flags/vi.svg": "36846",
  "./flags/vn.svg": "45841",
  "./flags/vu.svg": "54378",
  "./flags/wf.svg": "52074",
  "./flags/ws.svg": "39255",
  "./flags/xk.svg": "17594",
  "./flags/ye.svg": "42123",
  "./flags/yt.svg": "94826",
  "./flags/za.svg": "17866",
  "./flags/zm.svg": "50366",
  "./flags/zw.svg": "78884",
  "./google_plus.png": "54448",
  "./linkedin.png": "46224",
  "./login_bg_01.jpg": "6723",
  "./login_bg_02.jpg": "4916",
  "./login_bg_03.jpg": "83441",
  "./mailer/activation_customer/briefing_de.gif": "63876",
  "./mailer/activation_customer/briefing_en.gif": "57528",
  "./mailer/activation_customer/clickworker/briefing_de.gif": "52659",
  "./mailer/activation_customer/clickworker/briefing_en.gif": "94799",
  "./mailer/activation_customer/clickworker/confirm_de.gif": "91305",
  "./mailer/activation_customer/clickworker/confirm_en.gif": "70801",
  "./mailer/activation_customer/clickworker/load_data_de.gif": "50012",
  "./mailer/activation_customer/clickworker/load_data_en.gif": "53056",
  "./mailer/activation_customer/clickworker/preview_de.gif": "21521",
  "./mailer/activation_customer/clickworker/preview_en.gif": "23433",
  "./mailer/activation_customer/clickworker/startpage_de.gif": "71838",
  "./mailer/activation_customer/clickworker/startpage_en.gif": "77894",
  "./mailer/activation_customer/confirm_de.gif": "15672",
  "./mailer/activation_customer/confirm_en.gif": "22668",
  "./mailer/activation_customer/load_data_de.gif": "7157",
  "./mailer/activation_customer/load_data_en.gif": "96237",
  "./mailer/activation_customer/png/briefing_de.png": "23035",
  "./mailer/activation_customer/png/briefing_en.png": "92895",
  "./mailer/activation_customer/png/confirm_de.png": "40196",
  "./mailer/activation_customer/png/confirm_en.png": "67387",
  "./mailer/activation_customer/png/load_data_de.png": "71826",
  "./mailer/activation_customer/png/load_data_en.png": "94378",
  "./mailer/activation_customer/png/preview_de.png": "7435",
  "./mailer/activation_customer/png/preview_en.png": "77903",
  "./mailer/activation_customer/png/startpage_de.png": "17188",
  "./mailer/activation_customer/png/startpage_en.png": "22416",
  "./mailer/activation_customer/preview_de.png": "52079",
  "./mailer/activation_customer/preview_en.gif": "70960",
  "./mailer/activation_customer/resonio/briefing_de.gif": "67572",
  "./mailer/activation_customer/resonio/briefing_en.gif": "54792",
  "./mailer/activation_customer/resonio/confirm_de.gif": "53416",
  "./mailer/activation_customer/resonio/confirm_en.gif": "41116",
  "./mailer/activation_customer/resonio/load_data_de.gif": "8389",
  "./mailer/activation_customer/resonio/load_data_en.gif": "84381",
  "./mailer/activation_customer/resonio/preview_de.gif": "9308",
  "./mailer/activation_customer/resonio/preview_en.gif": "42976",
  "./mailer/activation_customer/resonio/startpage_de.gif": "26807",
  "./mailer/activation_customer/resonio/startpage_en.gif": "10931",
  "./mailer/activation_customer/startpage_de.gif": "60903",
  "./mailer/activation_customer/startpage_en.gif": "82787",
  "./mailer/confirmation_email_01.png": "34883",
  "./mailer/confirmation_email_02.png": "98024",
  "./mailer/confirmation_email_04.png": "1854",
  "./mailer/confirmation_email_05.png": "89543",
  "./mailer/send_instructions/s3_credentials.png": "42923",
  "./save_and_close.png": "4478",
  "./spellcheck2.png": "42192",
  "./twitter.png": "53481",
  "./workplace/SVG/Avatar.svg": "80832",
  "./workplace/SVG/CW-Logo-dark.svg": "52380",
  "./workplace/SVG/CW-Logo-light.svg": "93876",
  "./workplace/SVG/CW-Logo.svg": "21671",
  "./workplace/SVG/bulb.svg": "78618",
  "./workplace/SVG/clickworker-shorties-webapp-ico.svg": "94651",
  "./workplace/SVG/clickworker_ap_provider.svg": "34075",
  "./workplace/SVG/cw-loader.svg": "87647",
  "./workplace/SVG/cw-spinner.svg": "97361",
  "./workplace/SVG/defaultAvatar.svg": "98385",
  "./workplace/WorkplaceAppBanner.jpeg": "94959",
  "./workplace/activity_points/ap_bubble.png": "61519",
  "./workplace/activity_points/ap_bubble_purple.svg": "75877",
  "./workplace/activity_points/badges_png/reward_badge_aurora.png": "19942",
  "./workplace/activity_points/badges_png/reward_badge_aurora_ghost.png": "91142",
  "./workplace/activity_points/badges_png/reward_badge_base_ghost.png": "74461",
  "./workplace/activity_points/badges_png/reward_badge_bronze.png": "12470",
  "./workplace/activity_points/badges_png/reward_badge_bronze_ghost.png": "37558",
  "./workplace/activity_points/badges_png/reward_badge_gold.png": "54788",
  "./workplace/activity_points/badges_png/reward_badge_gold_ghost.png": "99972",
  "./workplace/activity_points/badges_png/reward_badge_iron.png": "31680",
  "./workplace/activity_points/badges_png/reward_badge_iron_ghost.png": "87408",
  "./workplace/activity_points/badges_png/reward_badge_silver.png": "16577",
  "./workplace/activity_points/badges_png/reward_badge_silver_ghost.png": "80545",
  "./workplace/activity_points/badges_png/reward_base_badge.png": "87589",
  "./workplace/activity_points/badges_png/reward_gift_badge.png": "85076",
  "./workplace/activity_points/display_name_icon.png": "60675",
  "./workplace/activity_points/ico_gradient/aurora-ico-gradient.svg": "36490",
  "./workplace/activity_points/ico_gradient/bronze-ico-gradient.svg": "16282",
  "./workplace/activity_points/ico_gradient/gift-ico-gradient.svg": "78320",
  "./workplace/activity_points/ico_gradient/gold-ico-gradient.svg": "42972",
  "./workplace/activity_points/ico_gradient/iron-ico-gradient.svg": "79936",
  "./workplace/activity_points/ico_gradient/mission-ico-gradient.svg": "17586",
  "./workplace/activity_points/ico_gradient/silver-ico-gradient.svg": "20523",
  "./workplace/activity_points/index_main_bg.png": "74725",
  "./workplace/activity_points/intro/activity_points_introduction_step_1_image.png": "64257",
  "./workplace/activity_points/intro/activity_points_introduction_step_2_image.png": "66226",
  "./workplace/activity_points/intro/activity_points_introduction_step_3_image.png": "39927",
  "./workplace/activity_points/intro/activity_points_introduction_step_4_image.png": "13408",
  "./workplace/activity_points/intro/activity_points_introduction_step_5_image.png": "86525",
  "./workplace/activity_points/intro/intro_gradient_bg.png": "12813",
  "./workplace/activity_points/payout_providers/amazon-logo.svg": "98304",
  "./workplace/activity_points/payout_providers/clickworker-logo.svg": "15710",
  "./workplace/activity_points/payout_providers/hm-logo.svg": "40591",
  "./workplace/activity_points/reward_badge_aurora.svg": "95956",
  "./workplace/activity_points/reward_badge_aurora_ghost.svg": "21836",
  "./workplace/activity_points/reward_badge_bronze.svg": "62040",
  "./workplace/activity_points/reward_badge_bronze_ghost.svg": "34032",
  "./workplace/activity_points/reward_badge_gold.svg": "90866",
  "./workplace/activity_points/reward_badge_gold_ghost.svg": "75666",
  "./workplace/activity_points/reward_badge_iron.svg": "15794",
  "./workplace/activity_points/reward_badge_iron_ghost.svg": "54450",
  "./workplace/activity_points/reward_badge_silver.svg": "31419",
  "./workplace/activity_points/reward_badge_silver_ghost.svg": "54507",
  "./workplace/activity_points/reward_base_badge.svg": "78699",
  "./workplace/activity_points/reward_gift_badge.svg": "26162",
  "./workplace/activity_points/shining_star_fx.svg": "75384",
  "./workplace/banners/more_to_do/more_to_do_about_you_card.jpg": "43645",
  "./workplace/banners/more_to_do/more_to_do_gender_card.jpg": "3673",
  "./workplace/banners/more_to_do/more_to_do_payout_card.jpg": "78526",
  "./workplace/banners/recruit_page_header_image.jpg": "81711",
  "./workplace/banners/uhrs_job_banner_variant1_image.jpg": "96157",
  "./workplace/banners/uhrs_job_banner_variant2_image.jpg": "9578",
  "./workplace/banners/uhrs_job_banner_variant3_image.jpg": "90299",
  "./workplace/banners/uhrs_job_banner_variant4_image.jpg": "76496",
  "./workplace/banners/uhrs_job_banner_variant5_image.jpg": "80873",
  "./workplace/banners/uhrs_job_banner_variant6_image.jpg": "64326",
  "./workplace/banners/uhrs_job_banner_variant7_image.jpg": "84407",
  "./workplace/banners/uhrs_qualify_banner_variant1_image.jpg": "51761",
  "./workplace/banners/uhrs_qualify_banner_variant2_image.jpg": "74254",
  "./workplace/banners/uhrs_qualify_banner_variant3_image.jpg": "39487",
  "./workplace/banners/uhrs_qualify_banner_variant4_image.jpg": "13564",
  "./workplace/banners/uhrs_qualify_banner_variant5_image.jpg": "48037",
  "./workplace/banners/uhrs_qualify_banner_variant6_image.jpg": "41106",
  "./workplace/banners/uhrs_qualify_banner_variant7_image.jpg": "41955",
  "./workplace/banners/uhrs_qualify_sticker_red.svg": "35928",
  "./workplace/emojis/happy.png": "60835",
  "./workplace/emojis/heart_eyes_happy.png": "76103",
  "./workplace/emojis/sad.png": "69261",
  "./workplace/emojis/sob.png": "17001",
  "./workplace/instructions/anBtn.png": "18132",
  "./workplace/instructions/hobbyBtn.png": "83959",
  "./workplace/instructions/knowhowBtn.png": "34540",
  "./workplace/instructions/knowhowDeBtn.png": "95031",
  "./workplace/intro-page/airtm.svg": "56152",
  "./workplace/intro-page/eu_bank_general_icon.png": "63726",
  "./workplace/intro-page/payoneer.svg": "10020",
  "./workplace/intro-page/paypal.svg": "54894",
  "./workplace/intro-page/sepa.svg": "89666",
  "./workplace/intro-page/step1-1-p.gif": "41244",
  "./workplace/intro-page/step1-1.gif": "99996",
  "./workplace/intro-page/step1-2-p.gif": "33008",
  "./workplace/intro-page/step1-2.gif": "61411",
  "./workplace/intro-page/step1-3-p.gif": "64981",
  "./workplace/intro-page/step1-3.gif": "96090",
  "./workplace/intro-page/step2-1-p.gif": "22440",
  "./workplace/intro-page/step2-1.gif": "491",
  "./workplace/intro-page/step2-2-p.gif": "17255",
  "./workplace/intro-page/step2-2.gif": "47972",
  "./workplace/intro-page/step2-3-p.gif": "97338",
  "./workplace/intro-page/step2-3.gif": "87229",
  "./workplace/intro-page/step3-1-p.gif": "29817",
  "./workplace/intro-page/step3-1.gif": "89878",
  "./workplace/intro-page/step3-2-p.gif": "99094",
  "./workplace/intro-page/step3-2.gif": "14849",
  "./workplace/intro-page/step3-3-p.gif": "99075",
  "./workplace/intro-page/step3-3.gif": "19016",
  "./workplace/intro-page/transferwise.svg": "78022",
  "./workplace/intro-page/us_bank_general_icon.png": "80408",
  "./workplace/job_type_bg/job_type_background_app_testing.svg": "14919",
  "./workplace/job_type_bg/job_type_background_categorization.svg": "71456",
  "./workplace/job_type_bg/job_type_background_data_collection.svg": "32916",
  "./workplace/job_type_bg/job_type_background_game_testing.svg": "85014",
  "./workplace/job_type_bg/job_type_background_general.svg": "56255",
  "./workplace/job_type_bg/job_type_background_image_annotation.svg": "54220",
  "./workplace/job_type_bg/job_type_background_inhouse.svg": "35784",
  "./workplace/job_type_bg/job_type_background_mystery_visit.svg": "83048",
  "./workplace/job_type_bg/job_type_background_photo_capturing.svg": "16985",
  "./workplace/job_type_bg/job_type_background_pre_screening.svg": "88061",
  "./workplace/job_type_bg/job_type_background_proofreading.svg": "59639",
  "./workplace/job_type_bg/job_type_background_research.svg": "80386",
  "./workplace/job_type_bg/job_type_background_review.svg": "40677",
  "./workplace/job_type_bg/job_type_background_robot_call.svg": "64142",
  "./workplace/job_type_bg/job_type_background_sentiment.svg": "1604",
  "./workplace/job_type_bg/job_type_background_survey.svg": "87919",
  "./workplace/job_type_bg/job_type_background_text_creation.svg": "80580",
  "./workplace/job_type_bg/job_type_background_transcription.svg": "79971",
  "./workplace/job_type_bg/job_type_background_video_creation.svg": "69954",
  "./workplace/job_type_bg/job_type_background_voice_recording.svg": "45085",
  "./workplace/login-bg.png": "17944",
  "./workplace/login-bg@2x.png": "61632",
  "./workplace/login-maskott.jpg": "13774",
  "./workplace/no_jobs_img.svg": "75166",
  "./workplace/patterns/1.png": "50568",
  "./workplace/patterns/10.png": "46554",
  "./workplace/patterns/11.png": "10659",
  "./workplace/patterns/2.png": "12547",
  "./workplace/patterns/3.png": "22714",
  "./workplace/patterns/4.png": "74773",
  "./workplace/patterns/5.png": "63148",
  "./workplace/patterns/6.png": "30183",
  "./workplace/patterns/7.png": "54398",
  "./workplace/patterns/8.png": "10153",
  "./workplace/patterns/9.png": "85952",
  "./workplace/patterns/christmas.png": "44837",
  "./workplace/pg_job_overlay.png": "33275",
  "./workplace/shorties_partying_face.png": "94459",
  "./workplace/social-ico/apple-ico-dark.svg": "83995",
  "./workplace/social-ico/apple-ico.svg": "48218",
  "./workplace/social-ico/facebook-ico.svg": "38914",
  "./workplace/social-ico/google-ico.svg": "32727",
  "./workplace/social-ico/microsoft-ico.svg": "91502",
  "./workplace/star_icons.png": "2078",
  "./workplace/welcome_bg/1.jpg": "83379",
  "./workplace/welcome_bg/2.jpg": "83332",
  "./workplace/welcome_bg/3.jpg": "61377",
  "./workplace/welcome_bg/4.jpg": "49682",
  "./workplace/xmas-notification-icon.svg": "45121",
  "./wrong_icon.png": "76719",
  "./xing.png": "66918"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 8257;
var map = {
  "./admin/CW-Logo-light.svg": "16974",
  "./admin/feather-sprite.svg": "83164",
  "./admin/icons/activity.svg": "93051",
  "./admin/icons/airplay.svg": "29382",
  "./admin/icons/alert-circle.svg": "45363",
  "./admin/icons/alert-octagon.svg": "8360",
  "./admin/icons/alert-triangle.svg": "68207",
  "./admin/icons/align-center.svg": "96735",
  "./admin/icons/align-justify.svg": "8324",
  "./admin/icons/align-left.svg": "42615",
  "./admin/icons/align-right.svg": "3314",
  "./admin/icons/anchor.svg": "35239",
  "./admin/icons/aperture.svg": "28540",
  "./admin/icons/archive.svg": "30622",
  "./admin/icons/arrow-down-circle.svg": "49718",
  "./admin/icons/arrow-down-left.svg": "54102",
  "./admin/icons/arrow-down-right.svg": "11413",
  "./admin/icons/arrow-down.svg": "91964",
  "./admin/icons/arrow-left-circle.svg": "69768",
  "./admin/icons/arrow-left.svg": "14411",
  "./admin/icons/arrow-right-circle.svg": "1003",
  "./admin/icons/arrow-right.svg": "37486",
  "./admin/icons/arrow-up-circle.svg": "49332",
  "./admin/icons/arrow-up-left.svg": "85899",
  "./admin/icons/arrow-up-right.svg": "32686",
  "./admin/icons/arrow-up.svg": "17815",
  "./admin/icons/at-sign.svg": "40263",
  "./admin/icons/award.svg": "62911",
  "./admin/icons/bar-chart-2.svg": "64137",
  "./admin/icons/bar-chart.svg": "8500",
  "./admin/icons/battery-charging.svg": "57521",
  "./admin/icons/battery.svg": "48531",
  "./admin/icons/bell-off.svg": "71135",
  "./admin/icons/bell.svg": "27655",
  "./admin/icons/bluetooth.svg": "11706",
  "./admin/icons/bold.svg": "37941",
  "./admin/icons/book-open.svg": "80980",
  "./admin/icons/book.svg": "30379",
  "./admin/icons/bookmark.svg": "87108",
  "./admin/icons/box.svg": "66863",
  "./admin/icons/briefcase.svg": "19632",
  "./admin/icons/calendar.svg": "14862",
  "./admin/icons/camera-off.svg": "349",
  "./admin/icons/camera.svg": "95561",
  "./admin/icons/cast.svg": "76625",
  "./admin/icons/check-circle.svg": "49665",
  "./admin/icons/check-square.svg": "13188",
  "./admin/icons/check.svg": "34836",
  "./admin/icons/chevron-down.svg": "64098",
  "./admin/icons/chevron-left.svg": "86921",
  "./admin/icons/chevron-right.svg": "76788",
  "./admin/icons/chevron-up.svg": "3665",
  "./admin/icons/chevrons-down.svg": "99245",
  "./admin/icons/chevrons-left.svg": "44182",
  "./admin/icons/chevrons-right.svg": "79989",
  "./admin/icons/chevrons-up.svg": "3346",
  "./admin/icons/chrome.svg": "35274",
  "./admin/icons/circle.svg": "7696",
  "./admin/icons/clipboard.svg": "82774",
  "./admin/icons/clock.svg": "96214",
  "./admin/icons/cloud-drizzle.svg": "56034",
  "./admin/icons/cloud-lightning.svg": "99350",
  "./admin/icons/cloud-off.svg": "65031",
  "./admin/icons/cloud-rain.svg": "40306",
  "./admin/icons/cloud-snow.svg": "52049",
  "./admin/icons/cloud.svg": "82159",
  "./admin/icons/code.svg": "92115",
  "./admin/icons/codepen.svg": "82572",
  "./admin/icons/coffee.svg": "60208",
  "./admin/icons/command.svg": "56207",
  "./admin/icons/compass.svg": "60452",
  "./admin/icons/copy.svg": "84795",
  "./admin/icons/corner-down-left.svg": "80554",
  "./admin/icons/corner-down-right.svg": "23361",
  "./admin/icons/corner-left-down.svg": "8964",
  "./admin/icons/corner-left-up.svg": "85151",
  "./admin/icons/corner-right-down.svg": "15827",
  "./admin/icons/corner-right-up.svg": "73804",
  "./admin/icons/corner-up-left.svg": "23671",
  "./admin/icons/corner-up-right.svg": "88370",
  "./admin/icons/cpu.svg": "7186",
  "./admin/icons/credit-card.svg": "798",
  "./admin/icons/crop.svg": "66334",
  "./admin/icons/crosshair.svg": "91200",
  "./admin/icons/database.svg": "63851",
  "./admin/icons/delete.svg": "3909",
  "./admin/icons/disc.svg": "84627",
  "./admin/icons/dollar-sign.svg": "60404",
  "./admin/icons/download-cloud.svg": "83408",
  "./admin/icons/download.svg": "34980",
  "./admin/icons/droplet.svg": "14426",
  "./admin/icons/edit-2.svg": "20805",
  "./admin/icons/edit-3.svg": "42788",
  "./admin/icons/edit.svg": "40008",
  "./admin/icons/external-link.svg": "48486",
  "./admin/icons/eye-off.svg": "62267",
  "./admin/icons/eye.svg": "55795",
  "./admin/icons/facebook.svg": "73136",
  "./admin/icons/fast-forward.svg": "50150",
  "./admin/icons/feather.svg": "70393",
  "./admin/icons/file-minus.svg": "86685",
  "./admin/icons/file-plus.svg": "39247",
  "./admin/icons/file-text.svg": "38426",
  "./admin/icons/file.svg": "97670",
  "./admin/icons/film.svg": "13998",
  "./admin/icons/filter.svg": "62362",
  "./admin/icons/flag.svg": "4546",
  "./admin/icons/folder-minus.svg": "88719",
  "./admin/icons/folder-plus.svg": "66945",
  "./admin/icons/folder.svg": "51592",
  "./admin/icons/frown.svg": "20484",
  "./admin/icons/gift.svg": "79750",
  "./admin/icons/git-branch.svg": "21441",
  "./admin/icons/git-commit.svg": "86142",
  "./admin/icons/git-merge.svg": "81459",
  "./admin/icons/git-pull-request.svg": "10372",
  "./admin/icons/github.svg": "23281",
  "./admin/icons/gitlab.svg": "91641",
  "./admin/icons/globe.svg": "667",
  "./admin/icons/grid.svg": "49516",
  "./admin/icons/hard-drive.svg": "50684",
  "./admin/icons/hash.svg": "83132",
  "./admin/icons/headphones.svg": "26197",
  "./admin/icons/heart.svg": "15712",
  "./admin/icons/help-circle.svg": "65498",
  "./admin/icons/home.svg": "32585",
  "./admin/icons/image.svg": "19123",
  "./admin/icons/inbox.svg": "24404",
  "./admin/icons/info.svg": "83456",
  "./admin/icons/instagram.svg": "200",
  "./admin/icons/italic.svg": "96508",
  "./admin/icons/layers.svg": "63290",
  "./admin/icons/layout.svg": "70190",
  "./admin/icons/life-buoy.svg": "66536",
  "./admin/icons/link-2.svg": "58577",
  "./admin/icons/link.svg": "82764",
  "./admin/icons/linkedin.svg": "42130",
  "./admin/icons/list.svg": "55524",
  "./admin/icons/loader.svg": "93061",
  "./admin/icons/lock.svg": "13969",
  "./admin/icons/log-in.svg": "29254",
  "./admin/icons/log-out.svg": "98081",
  "./admin/icons/mail.svg": "33121",
  "./admin/icons/map-pin.svg": "14012",
  "./admin/icons/map.svg": "88510",
  "./admin/icons/maximize-2.svg": "46379",
  "./admin/icons/maximize.svg": "23530",
  "./admin/icons/meh.svg": "57290",
  "./admin/icons/menu.svg": "36350",
  "./admin/icons/message-circle.svg": "20790",
  "./admin/icons/message-square.svg": "80331",
  "./admin/icons/mic-off.svg": "25305",
  "./admin/icons/mic.svg": "6677",
  "./admin/icons/minimize-2.svg": "71905",
  "./admin/icons/minimize.svg": "50524",
  "./admin/icons/minus-circle.svg": "93041",
  "./admin/icons/minus-square.svg": "55956",
  "./admin/icons/minus.svg": "72004",
  "./admin/icons/monitor.svg": "65966",
  "./admin/icons/moon.svg": "69895",
  "./admin/icons/more-horizontal.svg": "59240",
  "./admin/icons/more-vertical.svg": "81112",
  "./admin/icons/move.svg": "28803",
  "./admin/icons/music.svg": "3701",
  "./admin/icons/navigation-2.svg": "22235",
  "./admin/icons/navigation.svg": "12794",
  "./admin/icons/octagon.svg": "70661",
  "./admin/icons/package.svg": "70964",
  "./admin/icons/paperclip.svg": "65464",
  "./admin/icons/pause-circle.svg": "1023",
  "./admin/icons/pause.svg": "46098",
  "./admin/icons/percent.svg": "47871",
  "./admin/icons/phone-call.svg": "35949",
  "./admin/icons/phone-forwarded.svg": "75431",
  "./admin/icons/phone-incoming.svg": "15125",
  "./admin/icons/phone-missed.svg": "12182",
  "./admin/icons/phone-off.svg": "73372",
  "./admin/icons/phone-outgoing.svg": "13483",
  "./admin/icons/phone.svg": "5144",
  "./admin/icons/pie-chart.svg": "58757",
  "./admin/icons/play-circle.svg": "12079",
  "./admin/icons/play.svg": "54210",
  "./admin/icons/plus-circle.svg": "48729",
  "./admin/icons/plus-square.svg": "22972",
  "./admin/icons/plus.svg": "96812",
  "./admin/icons/pocket.svg": "15474",
  "./admin/icons/power.svg": "8991",
  "./admin/icons/printer.svg": "41080",
  "./admin/icons/radio.svg": "62261",
  "./admin/icons/refresh-ccw.svg": "35323",
  "./admin/icons/refresh-cw.svg": "84688",
  "./admin/icons/repeat.svg": "60721",
  "./admin/icons/rewind.svg": "40845",
  "./admin/icons/rotate-ccw.svg": "59663",
  "./admin/icons/rotate-cw.svg": "86812",
  "./admin/icons/rss.svg": "78872",
  "./admin/icons/save.svg": "32435",
  "./admin/icons/scissors.svg": "67685",
  "./admin/icons/search.svg": "24352",
  "./admin/icons/send.svg": "45086",
  "./admin/icons/server.svg": "93773",
  "./admin/icons/settings.svg": "91195",
  "./admin/icons/share-2.svg": "49012",
  "./admin/icons/share.svg": "92069",
  "./admin/icons/shield-off.svg": "13759",
  "./admin/icons/shield.svg": "10535",
  "./admin/icons/shopping-bag.svg": "97341",
  "./admin/icons/shopping-cart.svg": "89475",
  "./admin/icons/shuffle.svg": "4767",
  "./admin/icons/sidebar.svg": "56072",
  "./admin/icons/skip-back.svg": "97507",
  "./admin/icons/skip-forward.svg": "14021",
  "./admin/icons/slack.svg": "46748",
  "./admin/icons/slash.svg": "61951",
  "./admin/icons/sliders.svg": "77434",
  "./admin/icons/smartphone.svg": "38445",
  "./admin/icons/smile.svg": "51184",
  "./admin/icons/speaker.svg": "52039",
  "./admin/icons/square.svg": "20729",
  "./admin/icons/star.svg": "43748",
  "./admin/icons/stop-circle.svg": "22785",
  "./admin/icons/sun.svg": "85182",
  "./admin/icons/sunrise.svg": "12341",
  "./admin/icons/sunset.svg": "6382",
  "./admin/icons/tablet.svg": "9516",
  "./admin/icons/tag.svg": "6868",
  "./admin/icons/target.svg": "70879",
  "./admin/icons/terminal.svg": "94012",
  "./admin/icons/thermometer.svg": "2376",
  "./admin/icons/thumbs-down.svg": "45596",
  "./admin/icons/thumbs-up.svg": "49815",
  "./admin/icons/toggle-left.svg": "6194",
  "./admin/icons/toggle-right.svg": "42665",
  "./admin/icons/trash-2.svg": "83843",
  "./admin/icons/trash.svg": "47698",
  "./admin/icons/trello.svg": "72454",
  "./admin/icons/trending-down.svg": "83196",
  "./admin/icons/trending-up.svg": "41559",
  "./admin/icons/triangle.svg": "18792",
  "./admin/icons/truck.svg": "14581",
  "./admin/icons/tv.svg": "58790",
  "./admin/icons/twitter.svg": "37361",
  "./admin/icons/type.svg": "94164",
  "./admin/icons/umbrella.svg": "75784",
  "./admin/icons/underline.svg": "11992",
  "./admin/icons/unlock.svg": "88440",
  "./admin/icons/upload-cloud.svg": "88507",
  "./admin/icons/upload.svg": "68119",
  "./admin/icons/user-check.svg": "50226",
  "./admin/icons/user-minus.svg": "82670",
  "./admin/icons/user-plus.svg": "21510",
  "./admin/icons/user-x.svg": "96646",
  "./admin/icons/user.svg": "95309",
  "./admin/icons/users.svg": "88388",
  "./admin/icons/video-off.svg": "43033",
  "./admin/icons/video.svg": "46645",
  "./admin/icons/voicemail.svg": "63823",
  "./admin/icons/volume-1.svg": "78792",
  "./admin/icons/volume-2.svg": "13179",
  "./admin/icons/volume-x.svg": "87969",
  "./admin/icons/volume.svg": "34778",
  "./admin/icons/watch.svg": "8381",
  "./admin/icons/wifi-off.svg": "76763",
  "./admin/icons/wifi.svg": "45843",
  "./admin/icons/wind.svg": "38334",
  "./admin/icons/x-circle.svg": "377",
  "./admin/icons/x-square.svg": "5404",
  "./admin/icons/x.svg": "77068",
  "./admin/icons/youtube.svg": "62967",
  "./admin/icons/zap-off.svg": "89869",
  "./admin/icons/zap.svg": "17689",
  "./admin/icons/zoom-in.svg": "9827",
  "./admin/icons/zoom-out.svg": "67142",
  "./admin/node_builder_img/brands_logo/aws.svg": "49342",
  "./admin/node_builder_img/brands_logo/azure.svg": "69172",
  "./admin/node_builder_img/brands_logo/gemini.svg": "63606",
  "./admin/node_builder_img/brands_logo/google.svg": "48430",
  "./admin/node_builder_img/brands_logo/lxt.svg": "78105",
  "./admin/node_builder_img/brands_logo/microsoft.svg": "56641",
  "./admin/node_builder_img/brands_logo/openai.svg": "71125",
  "./admin/node_builder_img/icons/buyoff.svg": "17798",
  "./admin/node_builder_img/icons/createnode.svg": "54621",
  "./admin/node_builder_img/icons/data_annotation.svg": "56287",
  "./admin/node_builder_img/icons/data_annotation_validation.svg": "86855",
  "./admin/node_builder_img/icons/editnode.svg": "42745",
  "./admin/node_builder_img/icons/genai.svg": "81527",
  "./admin/node_builder_img/icons/ldp.svg": "73607",
  "./admin/node_builder_img/icons/llm.svg": "84122",
  "./admin/node_builder_img/icons/pre_annotation_llm.svg": "40560",
  "./admin/node_builder_img/icons/robotnode.svg": "3215",
  "./admin/node_builder_img/icons/startnode.svg": "60559",
  "./admin/node_builder_img/icons/stopnode.svg": "6925",
  "./admin/node_builder_img/icons/validationnode.svg": "94916",
  "./clickworker_com/2fa_step_1.png": "77443",
  "./clickworker_com/2fa_step_2.png": "99112",
  "./clickworker_com/2fa_step_3.png": "47505",
  "./clickworker_com/2fa_step_4.png": "2942",
  "./clickworker_com/app_download_qr_code.png": "31187",
  "./clickworker_com/clickworker_werben.png": "43929",
  "./clickworker_com/f2a_step_1_de.png": "94413",
  "./clickworker_com/f2a_step_2_de.png": "89164",
  "./clickworker_com/f2a_step_3_de.png": "75219",
  "./clickworker_logo_neu.png": "41523",
  "./crunchBase.png": "22498",
  "./facebook.png": "45158",
  "./favicon.ico": "66498",
  "./flags/3a.svg": "43617",
  "./flags/ad.svg": "62402",
  "./flags/ae.svg": "66131",
  "./flags/af.svg": "5120",
  "./flags/ag.svg": "19505",
  "./flags/ai.svg": "57303",
  "./flags/al.svg": "76570",
  "./flags/am.svg": "70443",
  "./flags/an.svg": "12376",
  "./flags/ao.svg": "37737",
  "./flags/aq.svg": "22671",
  "./flags/ar.svg": "20348",
  "./flags/as.svg": "48893",
  "./flags/at.svg": "14962",
  "./flags/au.svg": "18275",
  "./flags/aw.svg": "20001",
  "./flags/ax.svg": "62582",
  "./flags/az.svg": "61236",
  "./flags/ba.svg": "11845",
  "./flags/bb.svg": "22913",
  "./flags/bd.svg": "76559",
  "./flags/be.svg": "13982",
  "./flags/bf.svg": "68157",
  "./flags/bg.svg": "97532",
  "./flags/bh.svg": "48795",
  "./flags/bi.svg": "30954",
  "./flags/bj.svg": "91705",
  "./flags/bl.svg": "87239",
  "./flags/bm.svg": "118",
  "./flags/bn.svg": "41365",
  "./flags/bo.svg": "15732",
  "./flags/bq.svg": "67874",
  "./flags/br.svg": "22417",
  "./flags/bs.svg": "75968",
  "./flags/bt.svg": "18175",
  "./flags/bv.svg": "42541",
  "./flags/bw.svg": "62828",
  "./flags/by.svg": "51418",
  "./flags/bz.svg": "50153",
  "./flags/ca.svg": "74833",
  "./flags/cat.svg": "88159",
  "./flags/cc.svg": "82931",
  "./flags/cd.svg": "15244",
  "./flags/cf.svg": "65838",
  "./flags/cg.svg": "70591",
  "./flags/ch.svg": "67704",
  "./flags/ci.svg": "2569",
  "./flags/ck.svg": "22891",
  "./flags/cl.svg": "60740",
  "./flags/cm.svg": "15461",
  "./flags/cn.svg": "16326",
  "./flags/co.svg": "87511",
  "./flags/cr.svg": "86642",
  "./flags/cu.svg": "20573",
  "./flags/cv.svg": "66398",
  "./flags/cw.svg": "28975",
  "./flags/cx.svg": "19848",
  "./flags/cy.svg": "44121",
  "./flags/cz.svg": "83370",
  "./flags/de.svg": "18720",
  "./flags/dj.svg": "77847",
  "./flags/dk.svg": "6662",
  "./flags/dm.svg": "58040",
  "./flags/do.svg": "71789",
  "./flags/dz.svg": "29991",
  "./flags/ec.svg": "15899",
  "./flags/ee.svg": "90159",
  "./flags/eg.svg": "23325",
  "./flags/eh.svg": "71402",
  "./flags/er.svg": "53376",
  "./flags/es.svg": "93937",
  "./flags/et.svg": "28462",
  "./flags/eu.svg": "66399",
  "./flags/fi.svg": "26942",
  "./flags/fj.svg": "81117",
  "./flags/fk.svg": "91644",
  "./flags/fm.svg": "47186",
  "./flags/fo.svg": "4784",
  "./flags/fr.svg": "6629",
  "./flags/ga.svg": "59045",
  "./flags/gb-eng.svg": "13477",
  "./flags/gb-nir.svg": "70986",
  "./flags/gb-sct.svg": "79775",
  "./flags/gb-wls.svg": "8597",
  "./flags/gb.svg": "36614",
  "./flags/gd.svg": "61816",
  "./flags/ge.svg": "66057",
  "./flags/gf.svg": "97946",
  "./flags/gg.svg": "12555",
  "./flags/gh.svg": "85676",
  "./flags/gi.svg": "84621",
  "./flags/gl.svg": "98816",
  "./flags/gm.svg": "34769",
  "./flags/gn.svg": "14402",
  "./flags/gp.svg": "81108",
  "./flags/gq.svg": "53717",
  "./flags/gr.svg": "81846",
  "./flags/gs.svg": "45671",
  "./flags/gt.svg": "56488",
  "./flags/gu.svg": "38233",
  "./flags/gw.svg": "7227",
  "./flags/gy.svg": "33533",
  "./flags/hk.svg": "37194",
  "./flags/hm.svg": "71444",
  "./flags/hn.svg": "36007",
  "./flags/hr.svg": "9907",
  "./flags/ht.svg": "74957",
  "./flags/hu.svg": "76012",
  "./flags/ic.svg": "20789",
  "./flags/id.svg": "91690",
  "./flags/ie.svg": "60507",
  "./flags/il.svg": "52882",
  "./flags/im.svg": "78576",
  "./flags/in.svg": "66800",
  "./flags/io.svg": "57921",
  "./flags/iq.svg": "95223",
  "./flags/ir.svg": "40772",
  "./flags/is.svg": "21669",
  "./flags/it.svg": "14490",
  "./flags/je.svg": "42310",
  "./flags/jm.svg": "98286",
  "./flags/jo.svg": "33900",
  "./flags/jp.svg": "12923",
  "./flags/ke.svg": "31701",
  "./flags/kg.svg": "77575",
  "./flags/kh.svg": "1008",
  "./flags/ki.svg": "13249",
  "./flags/km.svg": "58493",
  "./flags/kn.svg": "4318",
  "./flags/kp.svg": "5624",
  "./flags/kr.svg": "41754",
  "./flags/ku.svg": "53381",
  "./flags/kw.svg": "25431",
  "./flags/ky.svg": "12753",
  "./flags/kz.svg": "58210",
  "./flags/la.svg": "96404",
  "./flags/lang.svg": "55305",
  "./flags/lb.svg": "67911",
  "./flags/lc.svg": "80790",
  "./flags/li.svg": "78204",
  "./flags/lk.svg": "94654",
  "./flags/lr.svg": "15767",
  "./flags/ls.svg": "28230",
  "./flags/lt.svg": "30825",
  "./flags/lu.svg": "95960",
  "./flags/lv.svg": "51147",
  "./flags/ly.svg": "43500",
  "./flags/ma.svg": "3563",
  "./flags/mc.svg": "99593",
  "./flags/md.svg": "96998",
  "./flags/me.svg": "90564",
  "./flags/mf.svg": "41412",
  "./flags/mg.svg": "96133",
  "./flags/mh.svg": "962",
  "./flags/mk.svg": "55505",
  "./flags/ml.svg": "46510",
  "./flags/mm.svg": "51263",
  "./flags/mn.svg": "95916",
  "./flags/mo.svg": "75629",
  "./flags/mp.svg": "64042",
  "./flags/mq.svg": "98235",
  "./flags/mr.svg": "520",
  "./flags/ms.svg": "47174",
  "./flags/mt.svg": "10825",
  "./flags/mu.svg": "20327",
  "./flags/mv.svg": "48820",
  "./flags/mw.svg": "90805",
  "./flags/mx.svg": "67314",
  "./flags/my.svg": "5251",
  "./flags/mz.svg": "43760",
  "./flags/na.svg": "1566",
  "./flags/nc.svg": "1468",
  "./flags/ne.svg": "79730",
  "./flags/nf.svg": "61473",
  "./flags/ng.svg": "63024",
  "./flags/ni.svg": "4054",
  "./flags/nl.svg": "87355",
  "./flags/no.svg": "5992",
  "./flags/np.svg": "56735",
  "./flags/nr.svg": "29517",
  "./flags/nu.svg": "20226",
  "./flags/nz.svg": "22341",
  "./flags/om.svg": "81769",
  "./flags/pa.svg": "96600",
  "./flags/pe.svg": "87076",
  "./flags/pf.svg": "91671",
  "./flags/pg.svg": "28870",
  "./flags/ph.svg": "27025",
  "./flags/pk.svg": "62978",
  "./flags/pl.svg": "72269",
  "./flags/pm.svg": "20460",
  "./flags/pn.svg": "99487",
  "./flags/pr.svg": "30107",
  "./flags/ps.svg": "4490",
  "./flags/pt.svg": "59765",
  "./flags/pw.svg": "46806",
  "./flags/py.svg": "5776",
  "./flags/qa.svg": "3759",
  "./flags/re.svg": "69358",
  "./flags/ro.svg": "40964",
  "./flags/rs.svg": "90288",
  "./flags/ru.svg": "12446",
  "./flags/rw.svg": "77148",
  "./flags/sa.svg": "673",
  "./flags/sb.svg": "95634",
  "./flags/sc.svg": "98947",
  "./flags/sd.svg": "1020",
  "./flags/se.svg": "29565",
  "./flags/sg.svg": "3343",
  "./flags/sh.svg": "87720",
  "./flags/si.svg": "83737",
  "./flags/sj.svg": "34442",
  "./flags/sk.svg": "3259",
  "./flags/sl.svg": "41908",
  "./flags/sm.svg": "63541",
  "./flags/sn.svg": "43254",
  "./flags/so.svg": "90119",
  "./flags/sr.svg": "43074",
  "./flags/ss.svg": "46803",
  "./flags/st.svg": "24236",
  "./flags/sv.svg": "88622",
  "./flags/sx.svg": "93048",
  "./flags/sy.svg": "18409",
  "./flags/sz.svg": "57242",
  "./flags/tc.svg": "73630",
  "./flags/td.svg": "91009",
  "./flags/tf.svg": "89283",
  "./flags/tg.svg": "85970",
  "./flags/th.svg": "53877",
  "./flags/tj.svg": "80455",
  "./flags/tk.svg": "33590",
  "./flags/tl.svg": "74073",
  "./flags/tm.svg": "78056",
  "./flags/tn.svg": "93595",
  "./flags/to.svg": "24778",
  "./flags/tr.svg": "93599",
  "./flags/tt.svg": "90513",
  "./flags/tv.svg": "37139",
  "./flags/tw.svg": "33410",
  "./flags/tz.svg": "28311",
  "./flags/ua.svg": "89555",
  "./flags/ug.svg": "14349",
  "./flags/um.svg": "80727",
  "./flags/us.svg": "43425",
  "./flags/uy.svg": "46011",
  "./flags/uz.svg": "30472",
  "./flags/va.svg": "87334",
  "./flags/vc.svg": "31748",
  "./flags/ve.svg": "74842",
  "./flags/vg.svg": "38712",
  "./flags/vi.svg": "36846",
  "./flags/vn.svg": "45841",
  "./flags/vu.svg": "54378",
  "./flags/wf.svg": "52074",
  "./flags/ws.svg": "39255",
  "./flags/xk.svg": "17594",
  "./flags/ye.svg": "42123",
  "./flags/yt.svg": "94826",
  "./flags/za.svg": "17866",
  "./flags/zm.svg": "50366",
  "./flags/zw.svg": "78884",
  "./google_plus.png": "54448",
  "./linkedin.png": "46224",
  "./login_bg_01.jpg": "6723",
  "./login_bg_02.jpg": "4916",
  "./login_bg_03.jpg": "83441",
  "./mailer/activation_customer/briefing_de.gif": "63876",
  "./mailer/activation_customer/briefing_en.gif": "57528",
  "./mailer/activation_customer/clickworker/briefing_de.gif": "52659",
  "./mailer/activation_customer/clickworker/briefing_en.gif": "94799",
  "./mailer/activation_customer/clickworker/confirm_de.gif": "91305",
  "./mailer/activation_customer/clickworker/confirm_en.gif": "70801",
  "./mailer/activation_customer/clickworker/load_data_de.gif": "50012",
  "./mailer/activation_customer/clickworker/load_data_en.gif": "53056",
  "./mailer/activation_customer/clickworker/preview_de.gif": "21521",
  "./mailer/activation_customer/clickworker/preview_en.gif": "23433",
  "./mailer/activation_customer/clickworker/startpage_de.gif": "71838",
  "./mailer/activation_customer/clickworker/startpage_en.gif": "77894",
  "./mailer/activation_customer/confirm_de.gif": "15672",
  "./mailer/activation_customer/confirm_en.gif": "22668",
  "./mailer/activation_customer/load_data_de.gif": "7157",
  "./mailer/activation_customer/load_data_en.gif": "96237",
  "./mailer/activation_customer/png/briefing_de.png": "23035",
  "./mailer/activation_customer/png/briefing_en.png": "92895",
  "./mailer/activation_customer/png/confirm_de.png": "40196",
  "./mailer/activation_customer/png/confirm_en.png": "67387",
  "./mailer/activation_customer/png/load_data_de.png": "71826",
  "./mailer/activation_customer/png/load_data_en.png": "94378",
  "./mailer/activation_customer/png/preview_de.png": "7435",
  "./mailer/activation_customer/png/preview_en.png": "77903",
  "./mailer/activation_customer/png/startpage_de.png": "17188",
  "./mailer/activation_customer/png/startpage_en.png": "22416",
  "./mailer/activation_customer/preview_de.png": "52079",
  "./mailer/activation_customer/preview_en.gif": "70960",
  "./mailer/activation_customer/resonio/briefing_de.gif": "67572",
  "./mailer/activation_customer/resonio/briefing_en.gif": "54792",
  "./mailer/activation_customer/resonio/confirm_de.gif": "53416",
  "./mailer/activation_customer/resonio/confirm_en.gif": "41116",
  "./mailer/activation_customer/resonio/load_data_de.gif": "8389",
  "./mailer/activation_customer/resonio/load_data_en.gif": "84381",
  "./mailer/activation_customer/resonio/preview_de.gif": "9308",
  "./mailer/activation_customer/resonio/preview_en.gif": "42976",
  "./mailer/activation_customer/resonio/startpage_de.gif": "26807",
  "./mailer/activation_customer/resonio/startpage_en.gif": "10931",
  "./mailer/activation_customer/startpage_de.gif": "60903",
  "./mailer/activation_customer/startpage_en.gif": "82787",
  "./mailer/confirmation_email_01.png": "34883",
  "./mailer/confirmation_email_02.png": "98024",
  "./mailer/confirmation_email_04.png": "1854",
  "./mailer/confirmation_email_05.png": "89543",
  "./mailer/send_instructions/s3_credentials.png": "42923",
  "./save_and_close.png": "4478",
  "./spellcheck2.png": "42192",
  "./twitter.png": "53481",
  "./workplace/SVG/Avatar.svg": "80832",
  "./workplace/SVG/CW-Logo-dark.svg": "52380",
  "./workplace/SVG/CW-Logo-light.svg": "93876",
  "./workplace/SVG/CW-Logo.svg": "21671",
  "./workplace/SVG/bulb.svg": "78618",
  "./workplace/SVG/clickworker-shorties-webapp-ico.svg": "94651",
  "./workplace/SVG/clickworker_ap_provider.svg": "34075",
  "./workplace/SVG/cw-loader.svg": "87647",
  "./workplace/SVG/cw-spinner.svg": "97361",
  "./workplace/SVG/defaultAvatar.svg": "98385",
  "./workplace/WorkplaceAppBanner.jpeg": "94959",
  "./workplace/activity_points/ap_bubble.png": "61519",
  "./workplace/activity_points/ap_bubble_purple.svg": "75877",
  "./workplace/activity_points/badges_png/reward_badge_aurora.png": "19942",
  "./workplace/activity_points/badges_png/reward_badge_aurora_ghost.png": "91142",
  "./workplace/activity_points/badges_png/reward_badge_base_ghost.png": "74461",
  "./workplace/activity_points/badges_png/reward_badge_bronze.png": "12470",
  "./workplace/activity_points/badges_png/reward_badge_bronze_ghost.png": "37558",
  "./workplace/activity_points/badges_png/reward_badge_gold.png": "54788",
  "./workplace/activity_points/badges_png/reward_badge_gold_ghost.png": "99972",
  "./workplace/activity_points/badges_png/reward_badge_iron.png": "31680",
  "./workplace/activity_points/badges_png/reward_badge_iron_ghost.png": "87408",
  "./workplace/activity_points/badges_png/reward_badge_silver.png": "16577",
  "./workplace/activity_points/badges_png/reward_badge_silver_ghost.png": "80545",
  "./workplace/activity_points/badges_png/reward_base_badge.png": "87589",
  "./workplace/activity_points/badges_png/reward_gift_badge.png": "85076",
  "./workplace/activity_points/display_name_icon.png": "60675",
  "./workplace/activity_points/ico_gradient/aurora-ico-gradient.svg": "36490",
  "./workplace/activity_points/ico_gradient/bronze-ico-gradient.svg": "16282",
  "./workplace/activity_points/ico_gradient/gift-ico-gradient.svg": "78320",
  "./workplace/activity_points/ico_gradient/gold-ico-gradient.svg": "42972",
  "./workplace/activity_points/ico_gradient/iron-ico-gradient.svg": "79936",
  "./workplace/activity_points/ico_gradient/mission-ico-gradient.svg": "17586",
  "./workplace/activity_points/ico_gradient/silver-ico-gradient.svg": "20523",
  "./workplace/activity_points/index_main_bg.png": "74725",
  "./workplace/activity_points/intro/activity_points_introduction_step_1_image.png": "64257",
  "./workplace/activity_points/intro/activity_points_introduction_step_2_image.png": "66226",
  "./workplace/activity_points/intro/activity_points_introduction_step_3_image.png": "39927",
  "./workplace/activity_points/intro/activity_points_introduction_step_4_image.png": "13408",
  "./workplace/activity_points/intro/activity_points_introduction_step_5_image.png": "86525",
  "./workplace/activity_points/intro/intro_gradient_bg.png": "12813",
  "./workplace/activity_points/payout_providers/amazon-logo.svg": "98304",
  "./workplace/activity_points/payout_providers/clickworker-logo.svg": "15710",
  "./workplace/activity_points/payout_providers/hm-logo.svg": "40591",
  "./workplace/activity_points/reward_badge_aurora.svg": "95956",
  "./workplace/activity_points/reward_badge_aurora_ghost.svg": "21836",
  "./workplace/activity_points/reward_badge_bronze.svg": "62040",
  "./workplace/activity_points/reward_badge_bronze_ghost.svg": "34032",
  "./workplace/activity_points/reward_badge_gold.svg": "90866",
  "./workplace/activity_points/reward_badge_gold_ghost.svg": "75666",
  "./workplace/activity_points/reward_badge_iron.svg": "15794",
  "./workplace/activity_points/reward_badge_iron_ghost.svg": "54450",
  "./workplace/activity_points/reward_badge_silver.svg": "31419",
  "./workplace/activity_points/reward_badge_silver_ghost.svg": "54507",
  "./workplace/activity_points/reward_base_badge.svg": "78699",
  "./workplace/activity_points/reward_gift_badge.svg": "26162",
  "./workplace/activity_points/shining_star_fx.svg": "75384",
  "./workplace/banners/more_to_do/more_to_do_about_you_card.jpg": "43645",
  "./workplace/banners/more_to_do/more_to_do_gender_card.jpg": "3673",
  "./workplace/banners/more_to_do/more_to_do_payout_card.jpg": "78526",
  "./workplace/banners/recruit_page_header_image.jpg": "81711",
  "./workplace/banners/uhrs_job_banner_variant1_image.jpg": "96157",
  "./workplace/banners/uhrs_job_banner_variant2_image.jpg": "9578",
  "./workplace/banners/uhrs_job_banner_variant3_image.jpg": "90299",
  "./workplace/banners/uhrs_job_banner_variant4_image.jpg": "76496",
  "./workplace/banners/uhrs_job_banner_variant5_image.jpg": "80873",
  "./workplace/banners/uhrs_job_banner_variant6_image.jpg": "64326",
  "./workplace/banners/uhrs_job_banner_variant7_image.jpg": "84407",
  "./workplace/banners/uhrs_qualify_banner_variant1_image.jpg": "51761",
  "./workplace/banners/uhrs_qualify_banner_variant2_image.jpg": "74254",
  "./workplace/banners/uhrs_qualify_banner_variant3_image.jpg": "39487",
  "./workplace/banners/uhrs_qualify_banner_variant4_image.jpg": "13564",
  "./workplace/banners/uhrs_qualify_banner_variant5_image.jpg": "48037",
  "./workplace/banners/uhrs_qualify_banner_variant6_image.jpg": "41106",
  "./workplace/banners/uhrs_qualify_banner_variant7_image.jpg": "41955",
  "./workplace/banners/uhrs_qualify_sticker_red.svg": "35928",
  "./workplace/emojis/happy.png": "60835",
  "./workplace/emojis/heart_eyes_happy.png": "76103",
  "./workplace/emojis/sad.png": "69261",
  "./workplace/emojis/sob.png": "17001",
  "./workplace/instructions/anBtn.png": "18132",
  "./workplace/instructions/hobbyBtn.png": "83959",
  "./workplace/instructions/knowhowBtn.png": "34540",
  "./workplace/instructions/knowhowDeBtn.png": "95031",
  "./workplace/intro-page/airtm.svg": "56152",
  "./workplace/intro-page/eu_bank_general_icon.png": "63726",
  "./workplace/intro-page/payoneer.svg": "10020",
  "./workplace/intro-page/paypal.svg": "54894",
  "./workplace/intro-page/sepa.svg": "89666",
  "./workplace/intro-page/step1-1-p.gif": "41244",
  "./workplace/intro-page/step1-1.gif": "99996",
  "./workplace/intro-page/step1-2-p.gif": "33008",
  "./workplace/intro-page/step1-2.gif": "61411",
  "./workplace/intro-page/step1-3-p.gif": "64981",
  "./workplace/intro-page/step1-3.gif": "96090",
  "./workplace/intro-page/step2-1-p.gif": "22440",
  "./workplace/intro-page/step2-1.gif": "491",
  "./workplace/intro-page/step2-2-p.gif": "17255",
  "./workplace/intro-page/step2-2.gif": "47972",
  "./workplace/intro-page/step2-3-p.gif": "97338",
  "./workplace/intro-page/step2-3.gif": "87229",
  "./workplace/intro-page/step3-1-p.gif": "29817",
  "./workplace/intro-page/step3-1.gif": "89878",
  "./workplace/intro-page/step3-2-p.gif": "99094",
  "./workplace/intro-page/step3-2.gif": "14849",
  "./workplace/intro-page/step3-3-p.gif": "99075",
  "./workplace/intro-page/step3-3.gif": "19016",
  "./workplace/intro-page/transferwise.svg": "78022",
  "./workplace/intro-page/us_bank_general_icon.png": "80408",
  "./workplace/job_type_bg/job_type_background_app_testing.svg": "14919",
  "./workplace/job_type_bg/job_type_background_categorization.svg": "71456",
  "./workplace/job_type_bg/job_type_background_data_collection.svg": "32916",
  "./workplace/job_type_bg/job_type_background_game_testing.svg": "85014",
  "./workplace/job_type_bg/job_type_background_general.svg": "56255",
  "./workplace/job_type_bg/job_type_background_image_annotation.svg": "54220",
  "./workplace/job_type_bg/job_type_background_inhouse.svg": "35784",
  "./workplace/job_type_bg/job_type_background_mystery_visit.svg": "83048",
  "./workplace/job_type_bg/job_type_background_photo_capturing.svg": "16985",
  "./workplace/job_type_bg/job_type_background_pre_screening.svg": "88061",
  "./workplace/job_type_bg/job_type_background_proofreading.svg": "59639",
  "./workplace/job_type_bg/job_type_background_research.svg": "80386",
  "./workplace/job_type_bg/job_type_background_review.svg": "40677",
  "./workplace/job_type_bg/job_type_background_robot_call.svg": "64142",
  "./workplace/job_type_bg/job_type_background_sentiment.svg": "1604",
  "./workplace/job_type_bg/job_type_background_survey.svg": "87919",
  "./workplace/job_type_bg/job_type_background_text_creation.svg": "80580",
  "./workplace/job_type_bg/job_type_background_transcription.svg": "79971",
  "./workplace/job_type_bg/job_type_background_video_creation.svg": "69954",
  "./workplace/job_type_bg/job_type_background_voice_recording.svg": "45085",
  "./workplace/login-bg.png": "17944",
  "./workplace/login-bg@2x.png": "61632",
  "./workplace/login-maskott.jpg": "13774",
  "./workplace/no_jobs_img.svg": "75166",
  "./workplace/patterns/1.png": "50568",
  "./workplace/patterns/10.png": "46554",
  "./workplace/patterns/11.png": "10659",
  "./workplace/patterns/2.png": "12547",
  "./workplace/patterns/3.png": "22714",
  "./workplace/patterns/4.png": "74773",
  "./workplace/patterns/5.png": "63148",
  "./workplace/patterns/6.png": "30183",
  "./workplace/patterns/7.png": "54398",
  "./workplace/patterns/8.png": "10153",
  "./workplace/patterns/9.png": "85952",
  "./workplace/patterns/christmas.png": "44837",
  "./workplace/pg_job_overlay.png": "33275",
  "./workplace/shorties_partying_face.png": "94459",
  "./workplace/social-ico/apple-ico-dark.svg": "83995",
  "./workplace/social-ico/apple-ico.svg": "48218",
  "./workplace/social-ico/facebook-ico.svg": "38914",
  "./workplace/social-ico/google-ico.svg": "32727",
  "./workplace/social-ico/microsoft-ico.svg": "91502",
  "./workplace/star_icons.png": "2078",
  "./workplace/welcome_bg/1.jpg": "83379",
  "./workplace/welcome_bg/2.jpg": "83332",
  "./workplace/welcome_bg/3.jpg": "61377",
  "./workplace/welcome_bg/4.jpg": "49682",
  "./workplace/xmas-notification-icon.svg": "45121",
  "./wrong_icon.png": "76719",
  "./xing.png": "66918"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 8257;
